import { record } from "@adora-so/rrweb";
import { debugLog } from "./debug";
export class RRwebRecorderImpl {
    /**
     * For some reason record in rrweb doesn't return the stopFn callback immediately (I have no idea how?!),
     * so we maintain an internal isRecording state rather than (more correctly) deriving it from the presence
     * of `stopFn`.
     **/
    _isRecording = false;
    stopFn;
    get isRecording() {
        return this._isRecording;
    }
    get mirror() {
        return record.mirror;
    }
    record(args) {
        debugLog("record", {
            stopFn: typeof this.stopFn,
            isRecording: this._isRecording,
        });
        if (this.stopFn !== undefined) {
            this.stop();
        }
        this._isRecording = true;
        this.stopFn = record(args);
        if (!this.stopFn) {
            throw new Error(`recorder could not successfully start`);
        }
    }
    stop() {
        this._isRecording = false;
        if (!this.stopFn) {
            return;
        }
        this.stopFn();
        this.stopFn = undefined;
    }
    addCustomEvent(tag, payload) {
        if (!this._isRecording) {
            debugLog("WARNING! attempting to add custom event with recording off");
            return false;
        }
        try {
            record.addCustomEvent(tag, payload);
        }
        catch (e) {
            // We have cases where we try to add custom events before they are
            // sent through.
            debugLog(`trying to record an event even though`, e);
            return false;
        }
        return true;
    }
}
